import {$window, $body} from '../../../Constants';
import SwiperSlider from '../../../Elements/SwiperSlider';

/**
 * Top Teaser Slider
 */
const TopTeaserSlider = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		TEASER_SLIDER: '.ig-teasers-type-4.swiper-container',
		NAV_PREV: '.swiper-button-prev',
		NAV_NEXT: '.swiper-button-next',
	};

	/**
	 * Class Name
	 *
	 * @var { Object }
	 */
	const ClassName = {
		CAN_CENTER: 'can-center'
	};

	/**
	 * Teaser Slider
	 *
	 * @class
	 * @augments SwiperSlider
	 */
	class TopTeaserSlider extends SwiperSlider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();
			this._$navPrev = this.$element.find(Selector.NAV_PREV);
			this._$navNext = this.$element.find(Selector.NAV_NEXT);

			this.setOptions({
				spaceBetween: !this.$element.hasClass('collapse') ? 30 : 0,
				slidesPerView: 1,
				grabCursor: true,
				loop: true,
				pagination: {
					el: this.constructor.Selector.PAGINATION,
					clickable: true
				},
				navigation: {
					nextEl: this._$navNext,
					prevEl: this._$navPrev
				},
				// Disable preloading of all images
				preloadImages: false,
				// Enable lazy loading
				lazy: true
			});

			this._initialize();
			this._bindHandlers();
			this._handleCentering();
			this._adjustArrowsPosition();
		}

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			$window.on('resize', () => {
				this._handleCentering();
				this._adjustArrowsPosition();
			});
		}

		/**
		 * Handles the centering by adding or removing the css class
		 *
		 * @return void
		 */
		_handleCentering() {
			this.$element.toggleClass(ClassName.CAN_CENTER, this.length < this.slider.params.slidesPerView);
		}

		_adjustArrowsPosition() {
			const $img = this.$element.find('.accessory-image img')[0]
			const topPosition = $img.offsetHeight / 2
			const arrowOffset = this._$navPrev[0].offsetHeight / 2
			this._$navPrev.css({'top' : (topPosition - arrowOffset) + 'px'})
			this._$navNext.css({'top' : (topPosition - arrowOffset) + 'px'})
		}
	}

	return TopTeaserSlider._getElements($body.find(Selector.TEASER_SLIDER), TopTeaserSlider);
})();

export default TopTeaserSlider;
